// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: rgb(241 247 255);
    width:400px;
    border-radius: 20px;
    direction: rtl;
    padding: 50px;

    
}
.loginPageCont{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
}
.login-form {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 70%;


}

.userLoginCont{
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    flex-direction: column;
}

.login-btn {
    margin: 20px;
    background-image: linear-gradient(to right, #71b3fa 0%, #204feb 51%, #368cdc 100%);
    text-transform: uppercase;
    transition: 0.5s;
    background-size: 200% auto;
    border-radius: 100px;
    padding: 10px 30px 10px 30px;
    text-align: center;
    border: none;
    width: -moz-fit-content;
    width: fit-content;
    font-weight: 500;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
}

.login-input {
    display: flex;
    margin: 10px;
    padding: 10px;
    border-radius: 5px;
    border: none;
    width: 100%;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
}

.logo-img{
    width: 100px;
    margin-bottom: 30px;
}
.login-title{
    margin-bottom: 20px;
    font-weight: 600;
}
.forgot-password-btn{
    background-color: rgb(241 247 255);
    text-decoration: underline;
    color: #204feb;
}`, "",{"version":3,"sources":["webpack://./src/components/AdminPage/usersControl/Login.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,aAAa;;;AAGjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,UAAU;;;AAGd;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,YAAY;IACZ,kFAAkF;IAClF,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,oBAAoB;IACpB,4BAA4B;IAC5B,kBAAkB;IAClB,YAAY;IACZ,uBAAkB;IAAlB,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX;;cAEU;AACd;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,cAAc;AAClB","sourcesContent":[".login-container {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    background-color: rgb(241 247 255);\r\n    width:400px;\r\n    border-radius: 20px;\r\n    direction: rtl;\r\n    padding: 50px;\r\n\r\n    \r\n}\r\n.loginPageCont{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    flex-direction: column;\r\n}\r\n.login-form {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    width: 70%;\r\n\r\n\r\n}\r\n\r\n.userLoginCont{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: 100vh;\r\n    flex-direction: column;\r\n}\r\n\r\n.login-btn {\r\n    margin: 20px;\r\n    background-image: linear-gradient(to right, #71b3fa 0%, #204feb 51%, #368cdc 100%);\r\n    text-transform: uppercase;\r\n    transition: 0.5s;\r\n    background-size: 200% auto;\r\n    border-radius: 100px;\r\n    padding: 10px 30px 10px 30px;\r\n    text-align: center;\r\n    border: none;\r\n    width: fit-content;\r\n    font-weight: 500;\r\n    color: #ffffff;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.login-input {\r\n    display: flex;\r\n    margin: 10px;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    border: none;\r\n    width: 100%;\r\n    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n}\r\n\r\n.logo-img{\r\n    width: 100px;\r\n    margin-bottom: 30px;\r\n}\r\n.login-title{\r\n    margin-bottom: 20px;\r\n    font-weight: 600;\r\n}\r\n.forgot-password-btn{\r\n    background-color: rgb(241 247 255);\r\n    text-decoration: underline;\r\n    color: #204feb;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
